/**
 * Words for what went wrong, and the two checks the search form makes before asking the
 * server. Pure, so the tests read them without the components.
 */
import { ApiClientError } from '../../api/client'
import { KODE_BENTUK, TEKS } from './strings'

function pesanUmum(error: ApiClientError): string | null {
  switch (error.kind) {
    case 'offline':
      return TEKS.offline
    case 'rate_limited':
      return TEKS.batas
    default:
      return null
  }
}

/** A server sentence (401, 403) is shown as it is; a bare transport failure gets ours. */
function pesanServer(error: ApiClientError): string {
  if (error.status === null || error.message === error.kind) return TEKS.gagal
  return error.message
}

export function pesanKegagalanKode(error: unknown): string {
  if (!(error instanceof ApiClientError)) return TEKS.gagal
  const umum = pesanUmum(error)
  if (umum !== null) return umum
  if (error.kind === 'not_found') return TEKS.kode.tidakDikenal
  if (error.kind === 'invalid') return KODE_BENTUK
  return pesanServer(error)
}

export function pesanKegagalanCari(error: unknown): string {
  if (!(error instanceof ApiClientError)) return TEKS.gagal
  return pesanUmum(error) ?? pesanServer(error)
}

export interface KesalahanMasukan {
  nama?: string
  tahun?: string
  /** The parent's name: its own field, never blamed on the name (final review 2, Minor 4). */
  orangTua?: string
}

/**
 * A run of five digits or more: a NIK or another number, never a name (finding C19). The search
 * travels in the request's address and its log, where a NIK may never go.
 */
export const DERET_NOMOR = /\d{5,}/

export function periksaMasukan(nama: string, tahun: string, orangTua = ''): KesalahanMasukan {
  const out: KesalahanMasukan = {}
  if (DERET_NOMOR.test(nama)) out.nama = TEKS.cari.tanpaNomor
  else if (nama.trim().length < 3) out.nama = TEKS.cari.namaPendek
  if (DERET_NOMOR.test(orangTua)) out.orangTua = TEKS.cari.tanpaNomor
  if (tahun.trim().length > 0 && !/^\d{4}$/.test(tahun.trim())) {
    out.tahun = TEKS.cari.tahunEmpatAngka
  }
  return out
}
